import React from "react";
import { useState, useEffect } from "react";
import { FaChevronLeft } from "react-icons/fa";
import "aos/dist/aos.css";
import { toast } from "react-toastify";
import axios from "axios";
import Footer from "../../components/footer";
import title from "../../assets/titleBrand.png";
import titleDetail from "../../assets/titleDetailvnd88.png";
import titleMB from "../../assets/titleBrand1.png";
import PromotionModal1 from "../../components/promotionModal1";
import ListPromotionModal from "../../components/listPromotionModal";
import VideoList from "../../components/videoList";
import styles from "./style.module.css";
import Loader from "../../components/loading";
import LoadingApply from "../../components/loadingApply";
import CryptoJS from "crypto-js";
import FingerprintJS from "@fingerprintjs/fingerprintjs";
import buttonBackHome from "../../assets/buttonBackHome.png";
import Header from "../../components/header";
import FloatingIPhoneFolderMenu from "../../components/FloatingIPhoneFolderMenu";
import btnIndex from "../../assets/button-trangchu.png";
import btnCSKH from "../../assets/button-cskh.png";
import formImage from "../../assets/form1.png";
import formMB from "../../assets/formMB1.png";
import btnConfirm from "../../assets/button-confirm.png";

import uuDaiTitle from "../../assets/uu-dai-title.png";
import titlesukien from "../../assets/titlesukien.png";

import bannerTop1 from "../../assets/banner-top-1.png";
import bannerTop2 from "../../assets/banner-top-2.png";

import card1 from "../../assets/card-1.png";
import card2 from "../../assets/card-2.png";
import card3 from "../../assets/card-3.png";
import card4 from "../../assets/card-4.png";

import iconQuality from "../../assets/icon-quality.png";
import iconGift from "../../assets/icon-gift.png";
import iconSupport from "../../assets/icon-support.png";
import iconSecurity from "../../assets/icon-security.png";

import { Navigation, Pagination, Scrollbar, A11y, FreeMode } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';

const HomePage = () => {
  const [activeButton, setActiveButton] = useState("promotions");
  const [username, setUsername] = useState("");
  const [captcha, setCaptcha] = useState("");
  const [captchaId, setCaptchaId] = useState("");
  const [captchaSvg, setCaptchaSvg] = useState("");
  const [promotions, setPromotions] = useState(null);
  const [listPromotions, setListPromotions] = useState(null);
  const [promotionsMB, setPromotionsMB] = useState(null);
  const [promotion, setPromotion] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [openListPromotionModal, setOpenListPromotionModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loadingApply, setLoadingApply] = useState(false);
  const [visibleCount, setVisibleCount] = useState(4);
  const [loadedImages, setLoadedImages] = useState({});
  const [showForbiddenModal, setShowForbiddenModal] = useState(false);
  const [config, setConfig] = useState([])
  const [showSwiper, setShowSwiper] = useState(true);
  const [videos, setVideos] = useState([]);
  const [videoPage, setVideoPage] = useState(1);
  const [videoTotalPages, setVideoTotalPages] = useState(1);
  const [videoLoading, setVideoLoading] = useState(false);

  const secretKey = "RR882024RR88";

  useEffect(() => {
    fetchCaptcha();
    fetchSetting();
    fetchPromotionMB();
    fetchPromotion();
    fetchVideos(1);
    setLoading(true);
  }, []);

  const fetchCaptcha = async () => {
    try {
      const fp = await FingerprintJS.load();
      const result = await fp.get();

      const fingerprint = result.visitorId;
      // lưu fingerprint để dùng lại lúc checkUsername
      sessionStorage.setItem("fp", fingerprint);

      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/captcha`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "X-Fingerprint": fingerprint,
          },
        }
      );
      const data = await response.json();

      if (data.statusCode === 200) {
        setCaptchaId(data.data.captchaId);
        setCaptchaSvg(data.data.captcha);
      } else {
        toast.error("Không thể tải Captcha");
      }
    } catch (error) {
      toast.error("Lỗi tải Captcha");
    }
  };

  const encryptData = (data) => {
    return CryptoJS.AES.encrypt(JSON.stringify(data), secretKey).toString();
  };

  const fetchPromotion = async () => {
    setLoading(true);
    const loadingTimeout = setTimeout(() => setLoading(false), 3000);

    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/promotion`
      );
      setPromotions(response.data.data.promotion);
      setLoading(false);
      clearTimeout(loadingTimeout);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const fetchSetting = async () => {
    setLoading(true);
    const loadingTimeout = setTimeout(() => setLoading(false), 3000);

    try {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/setting-public`);
      setLoading(false);
      setConfig(response.data)
      clearTimeout(loadingTimeout);
    } catch (error) {
      console.error('Error:', error);
    }
  };

  const fetchPromotionMB = async () => {
    const loadingTimeout = setTimeout(() => setLoading(false), 3000);
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/promotion?platform=M`
      );
      setPromotionsMB(response.data.data.promotion);
      setLoading(false);
      clearTimeout(loadingTimeout);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const fetchVideos = async (page = 1) => {
    if (videoLoading) return;
    setVideoLoading(true);
    try {
      const response = await axios.get(`${process.env.REACT_APP_VIDEO_API_URL}/videos?page=${page}&limit=20`);
      if (page === 1) {
        setVideos(response.data.items || []);
      } else {
        setVideos((prev) => [...prev, ...(response.data.items || [])]);
      }
      setVideoPage(response.data.page || page);
      setVideoTotalPages(response.data.totalPages || 1);
    } catch (error) {
      console.error("Error fetching videos:", error);
    } finally {
      setVideoLoading(false);
    }
  };

  const handleVideoTabClick = () => {
    setActiveButton("video");
    if (videos.length === 0) {
      fetchVideos(1);
    }
  };

  const loadMoreVideos = () => {
    if (videoPage < videoTotalPages) {
      fetchVideos(videoPage + 1);
    }
  };

  const formatViews = (views) => {
    if (views >= 1000) {
      return (views / 1000).toFixed(1) + "K";
    }
    return views;
  };

  const getTimeAgo = (dateString) => {
    const date = new Date(dateString);
    const now = new Date();
    const diffInSeconds = Math.floor((now - date) / 1000);

    const minutes = Math.floor(diffInSeconds / 60);
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);
    const months = Math.floor(days / 30);
    const years = Math.floor(months / 12);

    if (years > 0) return `${years} năm trước`;
    if (months > 0) return `${months} tháng trước`;
    if (days > 0) return `${days} ngày trước`;
    if (hours > 0) return `${hours} giờ trước`;
    if (minutes > 0) return `${minutes} phút trước`;
    return "Vừa xong";
  };

  const formatThumbnail = (url) => {
    if (!url) return "";
    if (url.startsWith("https")) return url;
    const baseDir = url.substring(0, url.lastIndexOf('/') + 1);
    return `https://6776.s3.de01.sonic.r-cdn.com${url}?pushr=${baseDir}`;
  };

  const checkUsername = async () => {
    if (!username.trim() || !captcha.trim()) {
      toast.warn("Vui lòng nhập đầy đủ thông tin!");
      return;
    }
    try {
      setLoadingApply(true);
      const fingerprint = sessionStorage.getItem("fp");

      // Mã hóa payload
      const encryptedPayload = encryptData({
        username: username.toLowerCase(),
        captcha,
        captchaId,
      });

      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/promotion/check`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-Fingerprint": fingerprint,
          },
          body: JSON.stringify({ data: encryptedPayload }), // Gửi payload đã mã hóa
        }
      );

      const data = await response.json();
      if (data.statusCode === 200) {
        setOpenListPromotionModal(true);
        setListPromotions(data.data.promotions);
      } else if (data.statusCode === 403) {
        setShowForbiddenModal(true); // Mở modal cảnh báo
      } else {
        toast.error(data?.message || "Có lỗi xảy ra!");
      }
      fetchCaptcha();
      setLoadingApply(false);
    } catch (error) {
      toast.error("Có lỗi xảy ra, vui lòng thử lại!");
    }
  };

  const clickPromotion = (promotion) => {
    setPromotion(promotion);
    setOpenModal(true);
  };

  const closeModal = () => {
    setOpenModal(false);
  };

  const closeListPromotionModal = () => {
    setOpenListPromotionModal(false);
  };

  const loadMore = () => {
    setVisibleCount((prev) => prev + 99);
  };

  const handleImageLoad = (id) => {
    setLoadedImages((prev) => ({ ...prev, [id]: true }));
  };

  const features = [
    {
      icon: iconQuality,
      title: "100% CHẤT LƯỢNG",
      desc: "Cam kết uy tín",
    },
    {
      icon: iconGift,
      title: "ƯU ĐÃI ĐỘC QUYỀN",
      desc: "Dành riêng cho bạn",
    },
    {
      icon: iconSupport,
      title: "HỖ TRỢ 24/7",
      desc: "Giải đáp mọi lúc",
    },
    {
      icon: iconSecurity,
      title: "BẢO MẬT TUYỆT ĐỐI",
      desc: "An toàn thông tin",
    },
  ];

  return (
    <>
      {loading && <Loader />}
      {loadingApply && <LoadingApply />}

      {/* DESKTOP */}
      <div className="relative bg-black min-h-screen flex flex-col md:block hidden overflow-hidden">
        <video
          autoPlay
          loop
          muted
          playsInline
          className="absolute top-0 left-0 w-full h-full object-cover z-0"
        >
          <source src="https://blob.kcam.io/uploads/alo8ttkmcode/bgttkmalo8.mp4" type="video/mp4" />
        </video>
        {/* Header có video background, cao 770px */}
        <div className="relative z-10 w-full h-full p-4 flex flex-col items-center justify-between overflow-hidden">
          {/* Nội dung header */}
          <div className="relative z-10 w-full flex flex-col items-center justify-between">
            {/* Hình ảnh tiêu đề */}
            <div className="flex-grow flex flex-col items-center pt-5 gap-1">
              <div className="w-[80%] h-auto flex justify-center mb-2">

                {/* Title cho desktop / tablet */}
                <img
                  src={titleMB}
                  alt="Title Desktop"
                  className={`hidden md:block w-[50%] h-auto  object-contain`}
                />
              </div>

              {/* 2 nút desktop */}
              <div className="w-full max-w-[400px] grid grid-cols-2 gap-7 ms-12">
                {/* TRANG CHỦ */}
                <a
                  href="https://vnd88lotto.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center justify-center transform transition-transform duration-200 hover:scale-105"
                  aria-label="Trang chủ"
                >
                  <img src={btnIndex} alt="TRANG CHỦ" className="max-w-full h-auto" />
                </a>

                {/* CSKH */}
                <a
                  href="https://vnd88-cskh.pages.dev/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center justify-center transform transition-transform duration-200 hover:scale-105"
                  aria-label="CSKH"
                >
                  <img src={btnCSKH} alt="CSKH" className="max-w-full h-auto" />
                </a>
              </div>

              <div className="w-full h-auto flex justify-center mt-2">
                <img
                  src={titleDetail}
                  alt="Title detail"
                  className="w-auto h-auto max-w-full object-contain"
                />
              </div>
            </div>

            {/* Form username + captcha */}

            <div className="relative  max-w-[1339px] md:translate-y-[-8%]">
              {/* Background form image */}
              <img
                src={formImage}
                alt="Form"
                className="md:translate-y-[5%]"
              />

              {/* FORM CONTENT */}
              <div
                className="
                  absolute
                  top-[32%]
                  left-[53%]
                  -translate-x-1/2
                  w-[72%]
                  flex
                  items-start
                  gap-[4%]
                "
              >
                {/* USERNAME */}
                <div className="flex flex-col gap-[0.4vw] w-[48%]">
                  <div className="text-[#EAC367] text-[1.4vw] font-semibold uppercase">
                    TÊN TÀI KHOẢN
                  </div>

                  <input
                    type="text"
                    placeholder="Nhập tên tài khoản"
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                    className="
                      w-full
                      h-[4vw]
                      min-h-[48px]
                      rounded-[0.4vw]
                      bg-[#0A0E18]
                      border border-[#5F6677]
                      text-white
                      text-[1.3vw]
                      px-[1.5vw]
                      outline-none
                      placeholder:text-[#8A8A8A]
                    "
                  />
                </div>

                {/* CAPTCHA */}
                <div className="flex flex-col gap-[0.4vw] w-[48%]">
                  <div className="text-[#EAC367] text-[1.4vw] font-semibold uppercase">
                    MÃ CAPTCHA
                  </div>

                  <div className="relative w-full">
                    <input
                      type="text"
                      placeholder="Nhập mã captcha"
                      value={captcha}
                      onChange={(e) => setCaptcha(e.target.value)}
                      className="
                        w-full
                        h-[4vw]
                        min-h-[48px]
                        rounded-[0.4vw]
                        bg-[#0A0E18]
                        border border-[#5F6677]
                        text-white
                        text-[1.3vw]
                        px-[1.5vw]
                        pr-[38%]
                        outline-none
                        placeholder:text-[#8A8A8A]
                      "
                    />

                    {captchaSvg && (
                      <div
                        className="
                          absolute
                          top-0
                          right-0
                          h-full
                          w-[35%]
                          bg-white
                          rounded-r-[0.4vw]
                          overflow-hidden
                          flex
                          items-center
                          justify-center
                          cursor-pointer
                        "
                        onClick={fetchCaptcha}
                      >
                        <div
                          className="scale-[0.8]"
                          dangerouslySetInnerHTML={{
                            __html: captchaSvg,
                          }}
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>

              {/* CONFIRM BUTTON */}
              <button
                onClick={checkUsername}
                className="
                  absolute
                  bottom-[17%]
                  left-1/2
                  -translate-x-1/2
                  w-[45%]
                  hover:scale-105
                  transition-transform
                  md:scale-[0.8]
                "
              >
                <img
                  src={btnConfirm}
                  alt="Xác nhận"
                  className="w-full h-auto"
                />
              </button>
            </div>

            {/* List promotion */}
            <div className="w-[85%] max-w-[1470px] flex flex-col items-center md:translate-y-[-5%]">
              {/* HEADER ROW */}
              <div className="relative flex justify-center items-center w-full">
                <img
                  src={titlesukien}
                  alt="Sự kiện nổi bật"
                  className="w-[500px] object-contain"
                />
              </div>
              <VideoList
                videos={videos}
                videoPage={videoPage}
                videoTotalPages={videoTotalPages}
                videoLoading={videoLoading}
                loadMoreVideos={loadMoreVideos}
                formatThumbnail={formatThumbnail}
                formatViews={formatViews}
                getTimeAgo={getTimeAgo}
                isMobile={false}
              />
            </div>

            {/* CÁC ƯU ĐÃI KHÁC */}
            <div className="w-[85%] max-w-[1470px] mx-auto mt-7 md:mt-2 mb-10">
              {/* HEADER ROW */}
              <div className="relative flex justify-center items-center mb-10 w-full">
                <img
                  src={uuDaiTitle}
                  alt="Các ưu đãi khác"
                  className="h-auto w-auto object-contain"
                />
              </div>

              {/* 2 BANNER TOP */}
              <div className="grid grid-cols-[1.4fr_1fr] gap-7 mb-20 items-center">
                <a
                  href="https://vnd88video.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src={bannerTop1}
                    alt="Ưu đãi 1"
                    className="w-auto h-[110%] rounded-[18px] hover:scale-[1.06] transition duration-300 cursor-pointer"
                  />
                </a>

                <img
                  src={bannerTop2}
                  alt="Ưu đãi 2"
                  className="w-auto h-[110%] rounded-[18px] hover:scale-[1.06] transition duration-300 cursor-pointer"
                />
              </div>

              {/* 4 CARD SMALL */}
              <div className="grid grid-cols-4 gap-4 mb-6">
                <img
                  src={card1}
                  alt="Nhập code"
                  className="w-full rounded-[16px] hover:scale-[1.02] transition duration-300 cursor-pointer"
                />

                <img
                  src={card2}
                  alt="Nhận mã dự thưởng"
                  className="w-full rounded-[16px] hover:scale-[1.02] transition duration-300 cursor-pointer"
                />

                <img
                  src={card3}
                  alt="Thiện nguyện"
                  className="w-full rounded-[16px] hover:scale-[1.02] transition duration-300 cursor-pointer"
                />

                <img
                  src={card4}
                  alt="Live realtime"
                  className="w-full rounded-[16px] hover:scale-[1.02] transition duration-300 cursor-pointer"
                />
              </div>

              {/* FEATURE BOTTOM */}
              <div className="rounded-[20px] border border-[#B88A3C]/40 bg-black/30 backdrop-blur-sm px-10 py-5">
                <div className="grid grid-cols-4 text-[#FFFFFF]">

                  {/* ITEM */}
                  <div className="relative flex items-center gap-3 pr-6 after:absolute after:right-0 after:top-1/2 after:h-[55px] after:w-px after:-translate-y-1/2 after:bg-gradient-to-b after:from-transparent after:via-[#EAC367]/50 after:to-transparent">
                    <img src={iconQuality} className="w-10 h-10" />
                    <div>
                      <div className="font-bold text-[20px] uppercase">
                        100% CHẤT LƯỢNG
                      </div>
                      <p className="text-[12px] text-[#B6B6B6]">
                        Cam kết uy tín
                      </p>
                    </div>
                  </div>

                  {/* ITEM */}
                  <div className="relative flex items-center gap-3 px-6 after:absolute after:right-0 after:top-1/2 after:h-[55px] after:w-px after:-translate-y-1/2 after:bg-gradient-to-b after:from-transparent after:via-[#EAC367]/50 after:to-transparent">
                    <img src={iconGift} className="w-10 h-10" />
                    <div>
                      <div className="font-bold text-[20px] uppercase">
                        ƯU ĐÃI ĐỘC QUYỀN
                      </div>
                      <p className="text-[12px] text-[#B6B6B6]">
                        Dành riêng cho bạn
                      </p>
                    </div>
                  </div>

                  {/* ITEM */}
                  <div className="relative flex items-center gap-3 px-6 after:absolute after:right-0 after:top-1/2 after:h-[55px] after:w-px after:-translate-y-1/2 after:bg-gradient-to-b after:from-transparent after:via-[#EAC367]/50 after:to-transparent">
                    <img src={iconSupport} className="w-10 h-10" />
                    <div>
                      <div className="font-bold text-[20px] uppercase">
                        HỖ TRỢ 24/7
                      </div>
                      <p className="text-[12px] text-[#B6B6B6]">
                        Giải đáp mọi lúc
                      </p>
                    </div>
                  </div>

                  {/* ITEM CUỐI - KHÔNG CÓ LINE */}
                  <div className="flex items-center gap-3 pl-6">
                    <img src={iconSecurity} className="w-10 h-10" />
                    <div>
                      <div className="font-bold text-[20px] uppercase">
                        BẢO MẬT TUYỆT ĐỐI
                      </div>
                      <p className="text-[12px] text-[#B6B6B6]">
                        An toàn thông tin
                      </p>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div >

      {/* MOBILE */}
      < div className="relative md:hidden block min-h-screen bg-black overflow-hidden" >
        <video
          autoPlay
          loop
          muted
          playsInline
          className="absolute top-0 left-0 w-full h-full object-cover z-0"
        >
          <source src="https://blob.kcam.io/uploads/alo8ttkmcode/bgttkmalo8.mp4" type="video/mp4" />
        </video>
        <div className="relative z-10 px-3 pb-6">

          {/* HEADER */}
          <div className="pt-5 flex flex-col items-center">
            <img
              src={titleMB}
              alt="Title"
              className="w-[220px] object-contain"
            />

            {/* BUTTONS */}
            <div className="flex gap-2 mt-3">
              <a href="https://vnd88lotto.com">
                <img
                  src={btnIndex}
                  className="w-[120px]"
                />
              </a>

              <a href="https://vnd88-cskh.pages.dev/">
                <img
                  src={btnCSKH}
                  className="w-[120px]"
                />
              </a>
            </div>

            {/* TITLE */}
            <img
              src={titleDetail}
              alt="Title Detail"
              className="w-[310px] mt-5"
            />
          </div>

          {/* LOGIN FORM */}
          <div className="relative">
            <img
              src={formImage}
              alt="form"
              className="w-full"
            />

            <div className="absolute top-[18%] right-[32%] translate-x-1/2 w-full flex flex-row items-center gap-1 md:gap-3">
              <div className="flex flex-col gap-1">
                <div className="text-[#EAC367] text-[11px] font-semibold uppercase">
                  TÊN TÀI KHOẢN
                </div>
                {/* Username */}
                <input
                  type="text"
                  placeholder="Nhập tên tài khoản"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  className="
                        w-[135px]
                        h-[35px]
                        px-4
                        rounded-[8px]
                        bg-[#0A0E18]
                        border border-[#5F6677]
                        text-white
                        text-[16px]
                        outline-none
                        placeholder:text-[#8A8A8A]
                      "
                />
              </div>

              <div className="flex flex-col gap-1">
                <div className="text-[#EAC367] text-[11px] font-semibold uppercase">
                  MÃ CAPTCHA
                </div>
                {/* Captcha input */}
                <div className="w-[150px] relative">
                  <input
                    type="text"
                    placeholder="Nhập mã captcha"
                    value={captcha}
                    onChange={(e) => setCaptcha(e.target.value)}
                    className="
                        w-[135px]
                        h-[35px]
                        px-4
                        rounded-[8px]
                        bg-[#0A0E18]
                        border border-[#5F6677]
                        text-white
                        text-[16px]
                        outline-none
                        pr-[70px]
                        placeholder:text-[#8A8A8A]
                      "
                  />

                  {captchaSvg && (
                    <div
                      className="
                          absolute 
                          w-[60px] 
                          h-[35px]
                          right-[5px]
                          top-0 
                          bottom-0 
                          rounded-md 
                          overflow-hidden 
                          cursor-pointer 
                          bg-white
                          flex items-center justify-center"
                      dangerouslySetInnerHTML={{ __html: captchaSvg }}
                      onClick={fetchCaptcha}
                    />
                  )}

                </div>
              </div>
            </div>

            {/* BUTTON */}
            <button
              onClick={checkUsername}
              className="
                absolute
                bottom-[22%]
                left-1/2
                -translate-x-1/2
                w-[40%]
                
              "
            >
              <img src={btnConfirm} />
            </button>
          </div>

          {/* PROMOTION GRID */}
          <div className="w-full  flex flex-col items-center">
            {/* HEADER ROW */}
            <div className="relative flex justify-center items-center  w-full">
              <img
                src={titlesukien}
                alt="Sự kiện nổi bật"
                className="w-[180px] object-contain"
              />
            </div>
            <VideoList
              videos={videos}
              videoPage={videoPage}
              videoTotalPages={videoTotalPages}
              videoLoading={videoLoading}
              loadMoreVideos={loadMoreVideos}
              formatThumbnail={formatThumbnail}
              formatViews={formatViews}
              getTimeAgo={getTimeAgo}
              isMobile={true}
            />
          </div>

          {/* HEADER ROW */}
          <div className="relative flex justify-center items-center mt-6 mb-3 w-full">
            <img
              src={uuDaiTitle}
              className="w-[180px] object-contain"
            />
          </div>

          {/* DEFAULT LAYOUT: PROMOTIONS */}
          <>
            {/* TOP BANNER */}
            <div className="grid grid-cols-[1.15fr_1fr] gap-2 items-center">
              <a
                href="https://vnd88video.com/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={bannerTop1}
                  className="w-full rounded-xl"
                />
              </a>

              <img
                src={bannerTop2}
                className="w-full rounded-xl scale-[1.05]"
              />
            </div>

            {/* 4 SMALL CARD */}
            <div className="grid grid-cols-4 gap-1 mt-3">
              <img src={card1} className="w-full" />
              <img src={card2} className="w-full" />
              <img src={card3} className="w-full" />
              <img src={card4} className="w-full" />
            </div>

            {/* FEATURE BOTTOM */}
            <div className="mt-4 rounded-xl border border-[#8A6A2F] bg-black/60 px-2 py-3">
              <div className="grid grid-cols-4">

                {features.map((item, index) => (
                  <div
                    key={index}
                    className={`
                      relative flex flex-col items-center text-center px-1
                      ${index !== 3
                        ? "after:absolute after:right-0 after:top-1/2 after:h-8 after:w-px after:-translate-y-1/2 after:bg-gradient-to-b after:from-transparent after:via-white/40 after:to-transparent"
                        : ""
                      }
                    `}
                  >
                    <img
                      src={item.icon}
                      className="w-5 h-5"
                    />
                    <div className="text-[8px] text-white font-semibold mt-1">
                      {item.title}
                    </div>
                    <div className="text-[6px] text-[#A8A8A8]">
                      {item.desc}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </>
        </div>
      </div >

      <Footer></Footer>
      <PromotionModal1
        isOpen={openModal === true}
        onClose={closeModal}
        promotion={promotion}
      />
      <ListPromotionModal
        isOpen={openListPromotionModal === true}
        onClose={closeListPromotionModal}
        promotions={listPromotions}
        username={username}
      />
      {
        showForbiddenModal && (
          <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
            <div className="bg-white rounded-lg shadow-lg p-6 w-11/12 sm:w-96">
              <h2 className="text-lg font-bold text-red-600 text-center">
                TÀI KHOẢN KHÔNG ĐƯỢC THAM GIA KHUYẾN MÃI
              </h2>
              <p className="text-sm text-gray-700 text-center mt-2">
                Vui lòng liên hệ CSKH 24/7 để được hỗ trợ.
              </p>
              <div className="mt-4 text-center">
                <a
                  href="https://vnd88-cskh.pages.dev/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-red-600 font-semibold hover:underline"
                >
                  https://vnd88-cskh.pages.dev/
                </a>
              </div>
              <div className="mt-4 flex justify-center">
                <button
                  onClick={() => setShowForbiddenModal(false)}
                  className="bg-gradient-to-b from-[#25C4AF] via-[#25C4AF] to-[#009F8A] hover:bg-red-600 text-white font-bold py-2 px-4 rounded-lg"
                >
                  Đóng
                </button>
              </div>
            </div>
          </div>
        )
      }
      {/* {showSwiper && config.find((c) => c.key === 'image:gif')?.value && (
        <div className="fixed bottom-0 left-0 w-full z-50 bg-transparent pb-2">
          <button
            className="absolute -top-3 left-10 bg-[#000000cc] text-white rounded-full w-7 h-7 flex items-center justify-center text-lg"
            onClick={() => setShowSwiper(false)}
          >
            ×
          </button>
          <div className="max-w-[500px] ml-10">
            <Swiper
              modules={[Navigation, Pagination, Scrollbar, A11y, FreeMode]}
              spaceBetween={10}
              slidesPerView={3}
              pagination={{ clickable: true }}
              freeMode={true}
              grabCursor={true}
              className="!ml-0"
            >
              <SwiperSlide>
                <a href={config.find((c) => c.key === 'link:gif')?.value || '#'}>
                  <img src={config.find((c) => c.key === 'image:gif')?.value || ''} className="rounded-lg w-full" />
                </a>
              </SwiperSlide>
            </Swiper>
          </div>
        </div>
      )} */}
      {/* <FloatingIPhoneFolderMenu /> */}
    </>
  );
};

export default HomePage;
